import {AuditType} from "../audit-model";
import {AuditAction} from "../audit-action";

export class AuditFilters {
  objectTypes: AuditType[];
  objectId: string;
  attributeName: string;
  actions: AuditAction[];
  username: string;
  organizationUuids: string[];
  from: number;
  until: number;
}
